import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ExtensionType, extensions } from '@pixi/extensions';
var ObjectRendererSystem = /*#__PURE__*/function () {
  function ObjectRendererSystem(renderer) {
    _classCallCheck(this, ObjectRendererSystem);
    this.renderer = renderer;
  }
  _createClass(ObjectRendererSystem, [{
    key: "render",
    value: function render(displayObject, options) {
      var _clear;
      var renderer = this.renderer;
      var renderTexture;
      var clear;
      var transform;
      var skipUpdateTransform;
      if (options) {
        renderTexture = options.renderTexture;
        clear = options.clear;
        transform = options.transform;
        skipUpdateTransform = options.skipUpdateTransform;
      }
      this.renderingToScreen = !renderTexture;
      renderer.runners.prerender.emit();
      renderer.emit("prerender");
      renderer.projection.transform = transform;
      if (renderer.context.isLost) {
        return;
      }
      if (!renderTexture) {
        this.lastObjectRendered = displayObject;
      }
      if (!skipUpdateTransform) {
        var cacheParent = displayObject.enableTempParent();
        displayObject.updateTransform();
        displayObject.disableTempParent(cacheParent);
      }
      renderer.renderTexture.bind(renderTexture);
      renderer.batch.currentRenderer.start();
      if ((_clear = clear) !== null && _clear !== void 0 ? _clear : renderer.background.clearBeforeRender) {
        renderer.renderTexture.clear();
      }
      displayObject.render(renderer);
      renderer.batch.currentRenderer.flush();
      if (renderTexture) {
        if (options.blit) {
          renderer.framebuffer.blit();
        }
        renderTexture.baseTexture.update();
      }
      renderer.runners.postrender.emit();
      renderer.projection.transform = null;
      renderer.emit("postrender");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.renderer = null;
      this.lastObjectRendered = null;
    }
  }]);
  return ObjectRendererSystem;
}();
ObjectRendererSystem.extension = {
  type: ExtensionType.RendererSystem,
  name: "objectRenderer"
};
extensions.add(ObjectRendererSystem);
export { ObjectRendererSystem };